import { useHttpClientContext } from '@/shared/context/HttpClientContext';
import { GetDealResponse } from '@schuettflix/interfaces';

export const useGetDealByOpportunityId = () => {
    const { salesforceDealImporterClient } = useHttpClientContext();
    return {
        getDealByOpportunityId: (opportunityId: string) =>
            salesforceDealImporterClient.get<GetDealResponse>(`/v1/deal/${opportunityId}`).then(res => res.data),
    };
};
